<template>
  <div class="enterpriseApplyFor">
    <van-sticky>
      <div
        class="enterpriseApplyForNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">申请成为企业代理人</span>
      </div>
    </van-sticky>
    <div class="content">
      <!-- 提示信息 -->
      <div class="enterpriseApplyFor_tip">
        根据相关法规要求，且为保护您的账号安全，须验证账号持有人的身份信息，确认用户所绑定的账号为本人持有。
      </div>
      <!-- 确认申请内容 -->
      <div class="card">
        <div class="title">
          <div class="title_top">
            <img src="./../../../assets/decoration/type1.png" alt="" />
            <h3>确认申请内容</h3>
          </div>
        </div>
        <div class="item">
          <p>缴费金额</p>
          <span v-if="userData.config"
            >￥{{ userData.config.enterpriseAgentCost }}</span
          >
        </div>
        <div class="item">
          <p>身份有效期</p>
          <span>1年</span>
        </div>
      </div>
      <!-- 确认申请人信息 -->
      <div class="card">
        <div class="title">
          <div class="title_top">
            <img src="./../../../assets/decoration/type2.png" alt="" />
            <h3>确认申请人信息</h3>
          </div>
        </div>
        <div class="item">
          <p>会员手机号</p>
          <span>{{ userData.phone }}</span>
        </div>
        <div class="item">
          <p>证件类型</p>
          <span v-if="userData.auth_type == 1">大陆身份证</span>
          <span v-if="userData.auth_type == 2">回乡证</span>
          <span v-if="userData.auth_type == 3">台胞证</span>
          <span v-if="userData.auth_type == 4">港澳台居民居住证</span>
          <span v-if="userData.auth_type == 5">外籍人永久居留身份证</span>
        </div>
        <div class="item">
          <p>真实姓名</p>
          <span>{{ userData.realname }}</span>
        </div>
        <div class="item">
          <p>证件号码</p>
          <span>{{ userData.id_number }}</span>
        </div>
      </div>
      <!-- 上传凭证 -->
      <div class="card">
        <div class="title">
          <div class="title_top">
            <img src="./../../../assets/decoration/type3.png" alt="" />
            <h3>填写资料信息</h3>
          </div>
        </div>
        <div class="littleTitle">填写企业信息</div>
        <div class="item upload">
          <p>营业执照</p>
          <div class="uploadContent">
            <van-uploader
              v-model="fileList1"
              :max-count="1"
              :accept="accept"
              multiple
              :after-read="zzafterRead"
              :before-read="beforeRead"
              @delete="deleteFile"
            >
              <div class="box">
                <img src="./../../../assets/decoration/order/yyzz.png" />
              </div>
            </van-uploader>
            <span>点击上传营业执照</span>
          </div>
        </div>
        <div class="item border-bottom">
          <p>企业名称</p>
          <span>
            <van-field
              v-model="company_name"
              input-align="right"
              placeholder="请输入企业名称"
              @blur="checkIsALLWrite"
            />
          </span>
        </div>
        <div class="item border-bottom">
          <p>统一社会信用代码</p>
          <span>
            <van-field
              v-model="credit_code"
              input-align="right"
              placeholder="请输入统一社会信用代码"
              @blur="checkIsALLWrite"
            />
          </span>
        </div>
        <div class="item border-bottom select">
          <p>证件有效期</p>
          <span
            @click="selectType(2)"
            :style="{
              color: license_validity_time ? '#333333' : '#CCCCCC',
              fontWeight: license_validity_time ? 'bold' : 'normal',
            }"
          >
            {{
              license_validity_time ? license_validity_time : "请选择证件有效期"
            }}
            <img src="./../../../assets/decoration/order/rl.png" alt="" />
          </span>
        </div>
        <div class="littleTitle">填写法定代表人信息</div>
        <div class="item border-bottom">
          <p>姓名</p>
          <span>
            <van-field
              v-model="legal_person"
              input-align="right"
              placeholder="请输入姓名"
              @blur="checkIsALLWrite"
            />
          </span>
        </div>
        <div class="item border-bottom select">
          <p>证件类型</p>
          <span
            @click="selectType(1)"
            :style="{
              color: idTypeName ? '#333333' : '#CCCCCC',
              fontWeight: idTypeName ? 'bold' : 'normal',
            }"
          >
            {{ this.idTypeName ? this.idTypeName : "请选择证件类型" }}
            <img src="./../../../assets/decoration/right.png" alt="" />
          </span>
        </div>
        <div class="item border-bottom">
          <p>证件号码</p>
          <span>
            <van-field
              v-model="id_card_number"
              input-align="right"
              placeholder="请输入证件号码"
              @blur="checkIsALLWrite"
            />
          </span>
        </div>
        <div class="item upload">
          <p>证件照片</p>
          <div class="uploadContent">
            <van-uploader
              v-model="fileList2"
              :max-count="1"
              :accept="accept"
              multiple
              :after-read="afterRead"
              :before-read="beforeRead"
              @delete="deleteFile"
            >
              <div class="box">
                <img src="./../../../assets/decoration/order/rmx.png" />
              </div>
            </van-uploader>
            <span>点击上传人像面</span>
          </div>
          <div class="uploadContent">
            <van-uploader
              v-model="fileList3"
              :max-count="1"
              :accept="accept"
              multiple
              :after-read="afterRead"
              :before-read="beforeRead"
              @delete="deleteFile"
            >
              <div class="box">
                <img src="./../../../assets/decoration/order/yyzz.png" />
              </div>
            </van-uploader>
            <span>点击上传非人像面</span>
          </div>
        </div>
        <div class="item border-bottom select">
          <p>证件有效期</p>
          <span
            @click="selectType(3)"
            :style="{
              color: id_card_validity_time ? '#333333' : '#CCCCCC',
              fontWeight: id_card_validity_time ? 'bold' : 'normal',
            }"
          >
            {{
              id_card_validity_time ? id_card_validity_time : "请选择证件有效期"
            }}
            <img src="./../../../assets/decoration/order/rl.png" alt="" />
          </span>
        </div>
      </div>
    </div>
    <div class="btm">
      <div class="agreement" @click.stop="isAgreement = !isAgreement">
        <img
          src="./../../../assets/decoration/uncheckedF.png"
          v-if="!isAgreement"
        />
        <img src="./../../../assets/decoration/checkedF.png" v-else />
        <p>
          我已经阅读并同意<span @click.stop="seeAgreement()"
            >《销巴装饰代理人合作须知》</span
          >
        </p>
      </div>
      <div class="btn">
        <span
          @click="submit()"
          :class="{ checkedBtn: isAgreement && isALLWrite }"
        >
          立即申请
        </span>
      </div>
    </div>
    <div class="order-loading" v-if="payLoading">
      <img src="../../../assets/shared-hotel/loading.gif" />
    </div>
    <!-- 类型选择 -->
    <van-action-sheet v-model="pickerShow" :title="pickerTitle">
      <div class="sheetContent">
        <div class="selectType" v-if="pickerType == 1">
          <p
            v-for="(item, index) in idTypeList"
            :class="{ check: item.checkd }"
            :key="index"
            @click="onSelect(item.label, item.value, index)"
          >
            {{ item.label }}
          </p>
        </div>
        <div class="selectValidity" v-if="pickerType == 2 || pickerType == 3">
          <div>
            <van-datetime-picker
              v-model="currentDate"
              type="date"
              title="选择证件有效期"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="validitySelect"
              @cancel="pickerShow = false"
            />
          </div>
          <p><span @click="longTimeValidity()">有效期为长期</span></p>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
import Upload from "./../../../providers/upload";
export default {
  data() {
    return {
      isiOSX: false,
      payLoading: false,
      isAgreement: false,
      fileList1: [], //营业执照
      fileList2: [], //身份证正面
      fileList3: [], //身份证背面
      userData: {},
      accept: "image/jpeg, image/jpg, image/png", //允许上传的图片类型
      pickerShow: false,
      pickerTitle: "",
      pickerType: 1, //1.证件类型2.营业执照有效期3.法人身份证有效期
      idTypeList: [], //身份证类型
      currentDate: new Date(),
      minDate: new Date(),
      maxDate: new Date(),
      company_name: "", //类型：String  必有字段  备注：企业名称
      credit_code: "", //类型：String  必有字段  备注：统一社会信用代码
      legal_person: "", //类型：String  必有字段  备注：法人姓名
      id_card_type: null, //类型：Number  必有字段  备注：法人证件类型（1大陆身份证 2回乡证 3台胞证 4港澳台居民居住证 5外籍人永久居留身份证）
      idTypeName: "",
      id_card_number: "", //类型：String  必有字段  备注：法人证件号码
      license_validity_time: null, //类型：String  可有字段  备注：营业执照有效时间（长期有效不传）
      id_card_validity_time: null, //类型：String  可有字段  备注：法人证件有效时间（长期有效不传）
      isALLWrite: false,
      needRefresh: true,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
  },
  activated() {
    if (this.needRefresh) {
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
      this.initData();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/cms-agreement/detail") {
      this.needRefresh = false;
    } else {
      this.needRefresh = true;
    }
    next();
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 初始化
    initData() {
      this.fileList1 = [];
      this.fileList2 = [];
      this.fileList3 = [];
      this.company_name = "";
      this.credit_code = "";
      this.legal_person = "";
      this.id_card_type = null;
      this.idTypeName = "";
      this.id_card_number = "";
      this.license_validity_time = null;
      this.id_card_validity_time = null;
      this.isALLWrite = false;
      this.getIdType();
      this.getAfterNYear();
      this.getConfigData();
      this.getData();
    },
    // 获取缴费金额和实名信息
    getConfigData() {
      this.$api
        .post("decoration/member/city/agent/get/money", {
          code: "EnterpriseAgentConfig",
          type: 2,
        })
        .then((res) => {
          this.userData = res;
        });
    },
    // 驳回数据回显
    getData() {
      this.$api
        .get("decoration/member/city/agent/enterprise/info")
        .then((res) => {
          if (res.enterprise_info) {
            res.enterprise_info.business_license.forEach((item, index) => {
              this.fileList1.push({ url: item });
            });
            this.company_name = res.enterprise_info.company_name;
            this.credit_code = res.enterprise_info.credit_code;
            this.license_validity_time =
              res.enterprise_info.license_validity_time_type == 1
                ? "长期有效"
                : res.enterprise_info.license_validity_time;
            this.legal_person = res.enterprise_info.legal_person;
            this.id_card_type = res.enterprise_info.id_card_type;
            this.idTypeList.forEach((item, index) => {
              if (item.value == this.id_card_type) {
                this.idTypeName = item.label;
              }
            });
            this.id_card_number = res.enterprise_info.id_card_number;
            res.enterprise_info.id_card_image.id_card_image_front.forEach(
              (item, index) => {
                this.fileList2.push({ url: item });
              }
            );
            res.enterprise_info.id_card_image.id_card_image_back.forEach(
              (item, index) => {
                this.fileList3.push({ url: item });
              }
            );
            this.id_card_validity_time =
              res.enterprise_info.id_card_validity_time_type == 1
                ? "长期有效"
                : res.enterprise_info.id_card_validity_time;
            this.checkIsALLWrite();
          }
        });
    },
    // 获取身份证类型
    getIdType() {
      this.$api.post("decoration/member/order/classify").then((res) => {
        this.idTypeList = res.card_type_list;
      });
    },
    // 计算当前时间后20年的日期
    getAfterNYear() {
      let date = new Date();
      let afterDate = `${date.getFullYear() + 20}/${
        date.getMonth() + 1
      }/${date.getDate()}`;
      this.maxDate = new Date(afterDate);
    },
    beforeRead(file) {
      if (file.size == 0 || JSON.stringify(file.file) == "{}") {
        //解决部分机型取消上传还是添加空白图片
        return false;
      } else {
        return true;
      }
    },
    // 营业执照上传
    zzafterRead(file) {
      this.afterRead(file, "zz");
    },
    afterRead(file, type) {
      if (Array.isArray(file)) {
        // 多选
        file.forEach((item) => {
          this.imgUpload(item, type);
        });
      } else {
        // 单选
        this.imgUpload(file, type);
      }
      this.checkIsALLWrite();
    },
    deleteFile() {
      this.checkIsALLWrite();
    },
    // 图片上传
    imgUpload(file, type) {
      file.status = "uploading";
      file.message = "上传中...";
      Upload.upload(file.file, ["others"])
        .then((res) => {
          file.status = "";
          file.message = "";
          file.url = res;
          // 如果营业执照上传成功，调取接口
          if (type == "zz") {
            this.getZz(res);
          }
        })
        .catch((res) => {
          file.status = "failed";
          file.message = "失败";
        });
    },
    // 查询营业执照获取信息
    getZz(url) {
      this.$api
        .post("decoration/member/order/license/info", { pic_url: url })
        .then((res) => {
          this.legal_person = res.legal_person;
          this.credit_code = res.credit_code;
          this.company_name = res.company_name;
        });
    },
    // 身份证类型及有效期选择弹窗
    selectType(type) {
      switch (type) {
        case 1:
          //证件类型
          this.pickerTitle = "请选择证件类型";
          break;
        case 2:
          //营业执照证件有效期
          this.pickerTitle = "";
          this.currentDate = new Date(this.license_validity_time);
          break;
        case 3:
          //法人身份证证件有效期
          this.pickerTitle = "";
          this.currentDate = new Date(this.id_card_validity_time);
          break;
        default:
      }
      this.pickerType = type;
      this.pickerShow = true;
    },
    // 身份证类型选择
    onSelect(label, value, index) {
      this.idTypeList.forEach((item) => {
        item.checkd = false;
      });
      this.idTypeList[index].checkd = true;
      this.idTypeName = label;
      this.id_card_type = value;
      this.pickerShow = false;
      this.checkIsALLWrite();
    },
    // 有效期选择
    validitySelect(e) {
      let selectDate = new Date(e);
      if (this.pickerType == 2) {
        // 营业执照有效期
        this.license_validity_time = `${selectDate.getFullYear()}/${
          selectDate.getMonth() + 1 > 9
            ? selectDate.getMonth() + 1
            : `0${selectDate.getMonth() + 1}`
        }/${
          selectDate.getDate() > 9
            ? selectDate.getDate()
            : `0${selectDate.getDate()}`
        }`;
      } else if (this.pickerType == 3) {
        // 法人证件有效期
        this.id_card_validity_time = `${selectDate.getFullYear()}/${
          selectDate.getMonth() + 1 > 9
            ? selectDate.getMonth() + 1
            : `0${selectDate.getMonth() + 1}`
        }/${
          selectDate.getDate() > 9
            ? selectDate.getDate()
            : `0${selectDate.getDate()}`
        }`;
      }
      this.pickerShow = false;
      this.checkIsALLWrite();
    },
    // 有效期设为长期有效
    longTimeValidity() {
      if (this.pickerType == 2) {
        // 营业执照有效期
        this.license_validity_time = "长期有效";
      } else if (this.pickerType == 3) {
        // 法人证件有效期
        this.id_card_validity_time = "长期有效";
      }
      this.pickerShow = false;
      this.checkIsALLWrite();
    },
    // 检查是否填写完整
    checkIsALLWrite() {
      if (
        this.company_name &&
        this.credit_code &&
        this.license_validity_time &&
        this.legal_person &&
        this.id_card_type &&
        this.id_card_number &&
        this.fileList1.length > 0 &&
        this.fileList2.length > 0 &&
        this.fileList3.length > 0 &&
        this.id_card_validity_time
      ) {
        this.isALLWrite = true;
      } else {
        this.isALLWrite = false;
      }
    },
    submit() {
      if (!this.isALLWrite) {
        this.$toast("请将所有信息填写完整");
        return;
      } else if (!this.isAgreement) {
        this.$toast("请先勾选协议");
        return;
      }
      let business_license_end = false;
      let id_card_image_front_end = false;
      let id_card_image_back_end = false;
      let business_license = []; //营业执照fileList1
      let id_card_image_front = []; //备注：法人证件图片正面fileList2
      let id_card_image_back = []; //备注：法人证件图片反面fileList3
      this.fileList1.forEach((item, index) => {
        if (item.url) {
          business_license.push(item.url);
        } else {
          this.$toast("文件正在上传中，请稍等");
          business_license_end = true;
          return;
        }
      });
      this.fileList2.forEach((item, index) => {
        if (item.url) {
          id_card_image_front.push(item.url);
        } else {
          this.$toast("文件正在上传中，请稍等");
          id_card_image_front_end = true;
          return;
        }
      });
      this.fileList3.forEach((item, index) => {
        if (item.url) {
          id_card_image_back.push(item.url);
        } else {
          this.$toast("文件正在上传中，请稍等");
          id_card_image_back_end = true;
          return;
        }
      });
      if (
        business_license_end ||
        id_card_image_front_end ||
        id_card_image_back_end
      ) {
        return;
      }
      this.payLoading = true;
      this.$api.get("decoration/basic/csrf/token").then((res) => {
        this.$api
          .post("decoration/member/city/agent/store", {
            payment_type: 2, //类型：Number  必有字段  备注：1:白名单首次录入,2:正常首次录入
            status: 10, //类型：Number  必有字段  备注：10：白名单，1：正常首次录入
            name: this.userData.realname, //类型：String  必有字段  备注：真实姓名
            id_number: this.userData.id_number, //类型：String  必有字段  备注：身份证号
            auth_type: this.userData.auth_type, //类型：String  必有字段  备注：证件类型 1大陆身份证、2回乡证、3台胞证、4港澳台居民居住证、5外籍人永久居留身份证
            type: 2, //类型：String  必有字段  备注：类型（1-个人；2-企业）
            enterprise_info: {
              //类型：Object  可有字段  备注：企业信息（企业代理人申请必传）
              company_name: this.company_name, //类型：String  必有字段  备注：企业名称
              credit_code: this.credit_code, //类型：String  必有字段  备注：统一社会信用代码
              business_license: business_license, //类型：Array  必有字段  备注：营业执照
              legal_person: this.legal_person, //类型：String  必有字段  备注：法人姓名
              id_card_type: this.id_card_type, //类型：Number  必有字段  备注：法人证件类型（1大陆身份证 2回乡证 3台胞证 4港澳台居民居住证 5外籍人永久居留身份证）
              id_card_number: this.id_card_number, //类型：String  必有字段  备注：法人证件号码
              id_card_image: {
                //类型：Object  必有字段  备注：法人证件照片
                id_card_image_front: id_card_image_front, //类型：Array  必有字段  备注：法人证件照片（正面）
                id_card_image_back: id_card_image_back, //类型：Array  必有字段  备注：法人证件照片（反面）
              },
              license_validity_time_type:
                this.license_validity_time == "长期有效" ||
                this.license_validity_time == null
                  ? 1
                  : 0, //类型：Number  必有字段  备注：营业执照时间类型（1-长期有效；0-指定时间有效）
              license_validity_time:
                this.license_validity_time == "长期有效"
                  ? null
                  : this.license_validity_time.replace(
                      new RegExp("/", "g"),
                      "-"
                    ), //类型：String  可有字段  备注：有效时间（长期有效不传）
              id_card_validity_time_type:
                this.id_card_validity_time == "长期有效" ||
                this.id_card_validity_time == null
                  ? 1
                  : 0, //类型：Number  必有字段  备注：法人证件时间类型（1-长期有效；0-指定时间有效）
              id_card_validity_time:
                this.id_card_validity_time == "长期有效"
                  ? null
                  : this.id_card_validity_time.replace(
                      new RegExp("/", "g"),
                      "-"
                    ), //类型：String  可有字段  备注：有效时间（长期有效不传）
            },
            csrf_token: res.csrf_token, //类型：String  必有字段  备注：防重复token
            amount: this.userData.config.enterpriseAgentCost,
          })
          .then((res) => {
            // 更新代理人身份
            this.$api
              .post("decoration/member/city/agent/switch/role", {
                type: 2,
              })
              .then((res) => {
                // 跳转详情
                this.$router.push({
                  path: "/decoration/deputy/details",
                });
                this.payLoading = false;
              });
          })
          .catch((err) => {
            this.ThrowError(err);
            this.payLoading = false;
          });
      });
    },
    ThrowError(err) {
      let keys = Object.keys(err);
      let key = keys[0];
      let message = err.message || err[key][0];
      if (message.slice(0, 10) == "timeout of") {
        this.$toast("网络不给力，请稍候重试");
      } else {
        this.$toast(message);
      }
      return;
    },
    // 查看协议
    seeAgreement(number) {
      this.$router.push({
        path: "/cms-agreement/detail",
        query: {
          entranceChannel: 1,
          number: "zsdlr1",
          isApp: 1,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.enterpriseApplyFor {
  min-height: 100%;
  background: #f5f6ff;
  color: #333;
  padding-bottom: 125px;
  h3 {
    margin: 0;
  }
  .enterpriseApplyForNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  //   内容
  .content {
    padding-bottom: 100px;
    .enterpriseApplyFor_tip {
      padding: 10px 13px;
      font-size: 14px;
      color: #ff7e31;
      line-height: 20px;
      background-color: rgba(255, 219, 198, 0.9);
    }
    .card {
      margin: 12px 16px 0;
      background: #ffffff;
      border-radius: 12px;
      padding: 24px 24px 32px;
      .title {
        padding-bottom: 2px;
        display: flex;
        height: 32px;
        border-bottom: 5px solid #d2c3ff;
        display: inline-block;
        .title_top {
          position: relative;
          top: 5px;
          display: flex;
          img {
            align-self: flex-end;
            width: 32px;
          }
          h3 {
            align-self: flex-end;
            font-size: 16px;
            font-weight: 600;
          }
        }
      }
      .littleTitle {
        font-size: 15px;
        font-weight: bold;
        color: #333333;
        line-height: 21px;
        margin-top: 32px;
      }
      .item {
        display: flex;
        justify-content: space-between;
        font-size: 15px;
        font-weight: 400;
        padding-top: 24px;
        p {
          color: #999999;
          flex-shrink: 0;
        }
        span {
          color: #333333;
          ::v-deep .van-field__body {
            input::placeholder,
            textarea::placeholder {
              color: #cccccc;
              font-weight: normal;
            }
            input,
            textarea {
              color: #333333;
              font-weight: bold;
              font-size: 14px;
            }
          }
          .van-cell {
            padding: 0;
          }
        }
      }
      .upload {
        display: flex;
        font-size: 14px;
        p {
          color: #666666;
        }
        .uploadContent {
          display: flex;
          flex-direction: column;
          align-items: center;
          img {
            width: 110px;
            height: 76px;
          }
          ::v-deep .van-uploader__preview {
            margin: 0;
          }
          ::v-deep .van-uploader__preview-image,
          ::v-deep .van-uploader__file {
            width: 110px;
            height: 76px;
            border-radius: 4px;
          }
          span {
            font-size: 12px;
            color: #999999;
            margin-top: 4px;
          }
        }
      }
      .border-bottom {
        border-bottom: 1px solid #f0f1ff;
        padding-bottom: 12px;
        font-size: 14px;
        p {
          color: #666666;
        }
      }
      .select {
        span {
          display: flex;
          align-items: center;
          font-size: 14px;
          img {
            width: 12px;
            height: 12px;
            margin-left: 6px;
          }
        }
      }
    }
  }
  // 底部按钮
  .btm {
    width: 100%;
    background-color: #f5f6ff;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    z-index: 99;
    .agreement {
      display: flex;
      color: #999999;
      margin: 14px 16px;
      font-size: 13px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
      p {
        flex: 1;
        span {
          color: #5853e9;
        }
      }
    }
    .btn {
      flex: 1;
      background-color: #ffffff;
      font-size: 16px;
      padding-bottom: 35px;
      span {
        margin: 2px 17px 0;
        display: block;
        background-color: rgba(88, 83, 233, 0.4);
        border-radius: 25px;
        height: 46px;
        line-height: 46px;
        text-align: center;
        color: #ffffff;
      }
      .checkedBtn {
        background-color: rgba(88, 83, 233, 1);
      }
    }
  }
  .order-loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }
  .sheetContent {
    .selectType {
      max-height: 500px;
      margin: 12px 0 55px;
      p {
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        padding: 12px 0;
        text-align: center;
      }
      .check {
        color: #5853e9;
      }
    }
    .selectValidity {
      height: 400px;
      display: flex;
      flex-direction: column;
      > div {
        overflow: hidden;
        flex: 1;
      }
      > p {
        height: 60px;
        flex-shrink: 0;
        border-top: 1px solid #f0f1ff;
        font-size: 16px;
        font-weight: bold;
        color: #5853e9;
        text-align: center;
        display: flex;
        justify-content: center;
        span {
          margin: 10px 0;
          height: 30px;
          line-height: 30px;
        }
      }
    }
  }
}
</style>